// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * A reference to a code defined by a terminology system.
 */
export type ICoding = fhir.IFhirElement & {
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code or an expression in a syntax defined by the coding system (e.g. post-coordination).
   */
  code?: string|undefined;
  _code?: fhir.IFhirElement|undefined;
  /**
   * A representation of the meaning of the code in the system, following the rules of the system.
   */
  display?: string|undefined;
  _display?: fhir.IFhirElement|undefined;
  /**
   * The URI may be an OID (urn:oid:...) or a UUID (urn:uuid:...).  OIDs and UUIDs SHALL be references to the HL7 OID registry. Otherwise, the URI should come from HL7's list of FHIR defined special URIs or it should reference to some definition that establishes the system clearly and unambiguously.
   */
  system?: string|undefined;
  _system?: fhir.IFhirElement|undefined;
  /**
   * Amongst a set of alternatives, a directly chosen code is the most appropriate starting point for new translations. There is some ambiguity about what exactly 'directly chosen' implies, and trading partner agreement may be needed to clarify the use of this element and its consequences more completely.
   */
  userSelected?: boolean|undefined;
  _userSelected?: fhir.IFhirElement|undefined;
  /**
   * Where the terminology does not clearly define what string should be used to identify code system versions, the recommendation is to use the date (expressed in FHIR date format) on which that version was officially published as the version date.
   */
  version?: string|undefined;
  _version?: fhir.IFhirElement|undefined;
}
/**
 * A reference to a code defined by a terminology system.
 */
export class Coding extends fhir.FhirElement implements fhir.ICoding {
  /**
   * A symbol in syntax defined by the system. The symbol may be a predefined code or an expression in a syntax defined by the coding system (e.g. post-coordination).
   */
  public code?: string|undefined;
  public _code?: fhir.FhirElement|undefined;
  /**
   * A representation of the meaning of the code in the system, following the rules of the system.
   */
  public display?: string|undefined;
  public _display?: fhir.FhirElement|undefined;
  /**
   * The URI may be an OID (urn:oid:...) or a UUID (urn:uuid:...).  OIDs and UUIDs SHALL be references to the HL7 OID registry. Otherwise, the URI should come from HL7's list of FHIR defined special URIs or it should reference to some definition that establishes the system clearly and unambiguously.
   */
  public system?: string|undefined;
  public _system?: fhir.FhirElement|undefined;
  /**
   * Amongst a set of alternatives, a directly chosen code is the most appropriate starting point for new translations. There is some ambiguity about what exactly 'directly chosen' implies, and trading partner agreement may be needed to clarify the use of this element and its consequences more completely.
   */
  public userSelected?: boolean|undefined;
  public _userSelected?: fhir.FhirElement|undefined;
  /**
   * Where the terminology does not clearly define what string should be used to identify code system versions, the recommendation is to use the date (expressed in FHIR date format) on which that version was officially published as the version date.
   */
  public version?: string|undefined;
  public _version?: fhir.FhirElement|undefined;
  /**
   * Default constructor for Coding - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.ICoding> = {}) {
    super(source);
    if (source["code"]) { this.code = source.code; }
    if (source["_code"]) { this._code = new fhir.FhirElement(source._code!); }
    if (source["display"]) { this.display = source.display; }
    if (source["_display"]) { this._display = new fhir.FhirElement(source._display!); }
    if (source["system"]) { this.system = source.system; }
    if (source["_system"]) { this._system = new fhir.FhirElement(source._system!); }
    if (source["userSelected"]) { this.userSelected = source.userSelected; }
    if (source["_userSelected"]) { this._userSelected = new fhir.FhirElement(source._userSelected!); }
    if (source["version"]) { this.version = source.version; }
    if (source["_version"]) { this._version = new fhir.FhirElement(source._version!); }
  }
  /**
   * Check if the current Coding contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Coding from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.ICoding):Coding {
    var dest:Coding = new Coding(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Coding is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
